import { Field, InputType } from 'type-graphql'
import { AdjustmentItem } from './AdjustmentItem'
import { ActionArgs } from '../action/ActionArgs'
import type { IAction } from '../action/IAction'
import type { Adjustment } from './Adjustment'

@InputType()
export class CreateAndFulfillAdjustmentArgs extends ActionArgs {
  @Field(() => [AdjustmentItem])
  items: AdjustmentItem[]

  @Field(() => String)
  remarks: string

  @Field(() => [String], { nullable: true })
  tags?: string[]
}

export interface ICreateAndAdjustService extends IAction<Adjustment, CreateAndFulfillAdjustmentArgs> {}
